// Module
var code = "<h2 class=\"modal-title\">\n  <!-- ko template: { nodes: $componentTemplateNodes } -->\n  <!-- /ko -->\n</h2>\n\n<button type=\"button\" class=\"close\" aria-label=\"Close\" data-bind=\"click: close\">\n  <span aria-hidden=\"true\">×</span>\n</button>\n";
// Exports
module.exports = code;